import styled from 'styled-components';
import { Label, Input } from '@spa/shared/components/Checkbox';
import { FilterCard } from '@spa/shared/components/Filters/styles';

export const Container = styled.div`
  ${Label} {
    ${FilterCard}
    display: flex;
    align-items: center;
    cursor: pointer;

    ${props => props.hasHelperText && 'height: 60px;'}

    svg {
      width: auto;
    }
  }

  ${Input} {
    display: none;

    &:checked ~ ${Label} {
      background: ${props => props.theme.filter.checkbox.checked.background};
      color: ${props => props.theme.filter.checkbox.checked.color};
      border-color: ${props => props.theme.filter.checkbox.checked.borderColor};
      box-shadow: none;
    }
  }
`;

export const BadgesGroup = styled.span`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.space(1)};
  margin-left: auto;
`;
